/* eslint-disable no-console */
import React from 'react';

import {ReactComponent as Minus} from '../../../assets/MinusOutlined.svg';
import {ReactComponent as Plus} from '../../../assets/PlusOutlined.svg';

const CustomExpandButton: React.FC<{data: any; children: any}> = ({
  data,
  children
}) => {
  const btnWidth = 16;

  const styles = {
    expandBtn: {
      width: btnWidth,
      height: btnWidth,
      margin: 'auto',
      color: '#F3F4F8',
      backgroundColor: '#024064',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      cursor: 'pointer'
    },
    flex: {
      display: 'flex'
    }
  };

  return (
    <>
      {data && (
        <div style={styles.expandBtn}>
          {/* <span>{data._directSubordinates}</span> */}
          <span style={styles.flex}>{children ? <Minus /> : <Plus />}</span>
        </div>
      )}
    </>
  );
};

export default CustomExpandButton;
